import React from 'react'
import clsx from 'clsx'
import { TextField, FormControl } from '@material-ui/core'
import useStyles from './FormFieldsStyle'

export default function TextArea({ field, values, setValues, errors }) {
  const classes = useStyles()

  return (
    <FormControl fullWidth className={classes.withMargin} variant="outlined">
      <div className={classes.inputLabel} shrink>
        {field.label}
      </div>
      <TextField
        InputProps={{
          placeholder: field.hint,
        }}
        InputLabelProps={{
          shrink: true,
        }}
        variant="outlined"
        name={field.key}
        onChange={(event) => {
          delete errors[field.key]
          setValues({ ...values, [field.key]: event.target.value })
        }}
        value={values[field.key]}
        error={!!errors[field.key]}
        helperText={errors[field.key]}
        fullWidth
        multiline
        minRows={field.rows || 3}
        maxRows={20}
        style={{ marginTop: 8 }}
      />
    </FormControl>
  )
}
